import healthIcon from '../resources/health.png';
import hungerIcon from '../resources/hunger.png';

const ProgressBar = (props) => {
    const { isHealth, bgcolor, completed } = props;

    const icon = isHealth ? healthIcon : hungerIcon;

    const trStyles = {
      margin: "5px 0"
    }

    const iconContainerStyles = {
      padding: "0 5px 0 5px"
    }

    const iconStyles = {
      height: "25px",
      width: "auto"
    }

    const containerStyles = {
      height: 20,
      width: '100%',
      backgroundColor: "#e0e0de",
      borderRadius: 50,
    }
  
    const fillerStyles = {
      height: '100%',
      width: `${completed}%`,
      backgroundColor: bgcolor,
      borderRadius: 'inherit',
      textAlign: 'right'
    }
  
    const labelStyles = {
      padding: 5,
      color: 'white',
      fontWeight: 'bold'
    }
  
    return (
      <tr style={trStyles}>
        <td style={iconContainerStyles}>
          <img alt="" style={iconStyles} src={icon} />
        </td>
        <td style={containerStyles}>
          <div style={fillerStyles}>
            <span style={labelStyles}>{`${completed}%`}</span>
          </div>
        </td>
      </tr>
    );
  };
  
  export default ProgressBar;
  